import axiosInstance from '@api/axios-instance.ts';
import {
  InternalServersConfigurationModel,
  InternalServersConfigurationReqModel
} from '@models/internal-servers-configuration.model.ts';
import useTokenStore from '@store/token-store/token.store.ts';

export const getInternalServers = async (): Promise<
  InternalServersConfigurationModel[]
> => {
  const response = await axiosInstance.get('/settings/internal-servers');
  return response.data;
};

export const testConnectionInternalServers = async (
  url: string
): Promise<any> => {
  const { accessToken } = useTokenStore.getState();
  const headers: Record<string, string> = {};

  if (accessToken) {
    headers.Authorization = `Bearer ${accessToken}`;
  }

  const response = await window.electronAPI.httpRequest({
    method: 'GET',
    url: `${url}/health`,
    headers
  });

  if (!response.ok) {
    throw new Error(response.error || 'Electron request failed');
  }

  return response.data;
};

export const createInternalServer = async (
  body: InternalServersConfigurationReqModel
): Promise<InternalServersConfigurationModel> => {
  return await axiosInstance.post(`/settings/internal-servers`, body);
};

export const editInternalServer = async (
  body: InternalServersConfigurationReqModel,
  id: string
): Promise<InternalServersConfigurationModel> => {
  return await axiosInstance.put(`/settings/internal-servers/${id}`, body);
};
